import { Head } from "@inertiajs/react";
import { t } from "@travily/i18n";
import {
  foundingMemberCreatorPath,
  foundingMemberCreatorPausePath,
  foundingMemberCreatorStagePath,
} from "@travily/routes";
import type FoundingMemberCreatorCommunityConnect from "@travily/types/pages/FoundingMemberCreatorCommunityConnect";
import { useCreatorTopBarActions } from "@/lib/wizard/use-creator-top-bar-actions";
import { useWizardForm } from "@/lib/wizard/use-wizard-form";
import { FoundingMemberCommunityConnectStepView } from "./show.view";

type FormData = {
  community_profile: {
    socials: string;
  };
};

const FIELD = "community_profile.socials";

const ConnectStep = ({ stage_index, stage_order, community_profile }: FoundingMemberCreatorCommunityConnect) => {
  const { form, validate, fieldError, currentStage, totalStages, onBack, onPrimary, primaryPending, onPause } =
    useWizardForm<FormData>({
      routes: {
        stageUrl: (stage) => foundingMemberCreatorStagePath("community", stage),
        entryUrl: foundingMemberCreatorPath(),
        pauseUrl: foundingMemberCreatorPausePath(),
      },
      stageName: "connect",
      stageIndex: stage_index,
      stageOrder: stage_order,
      initialData: { community_profile: { socials: community_profile.socials ?? "" } },
    });

  const error = fieldError(FIELD);

  const topBarActions = useCreatorTopBarActions({ onPause });

  return (
    <>
      <Head title={t("web.founding_members.creator.steps.community.connect.show.meta_title")}>
        <meta
          name="description"
          content={t("web.founding_members.creator.steps.community.connect.show.meta_description")}
        />
      </Head>
      <FoundingMemberCommunityConnectStepView
        currentStage={currentStage}
        totalStages={totalStages}
        onBack={onBack}
        topBarActions={topBarActions}
        onPrimary={onPrimary}
        primaryPending={primaryPending}
        socials={form.data.community_profile.socials}
        error={error}
        onSocialsChange={(value) => {
          form.setData(FIELD, value);
          validate(FIELD);
        }}
      />
    </>
  );
};

export default ConnectStep;
